import { createApp } from 'vue'
import Earthquake from './Earthquake.vue'
import './assets/global.css'

createApp(Earthquake).mount('#earthquake')
